module.exports = __webpack_public_path__ + "img/end-event.1ad31396.svg";